var _defs, _circle, _rect, _polyline, _rect2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-1,.cls-2,.cls-3,.cls-4{stroke:#0090b9;stroke-width:2px;}.cls-1,.cls-2,.cls-4{stroke-miterlimit:10;}.cls-2,.cls-4{fill:#b3ddee;}.cls-3{stroke-linecap:round;stroke-linejoin:round;}.cls-4{opacity:0.5;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 76.23,
    cy: 80.15,
    r: 66.55
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.22,
    y: 38.68,
    width: 18.04,
    height: 15.54
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "42.59 46.87 44.82 49.65 50.95 42.41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 93.52,
    y: 38.73,
    width: 18.04,
    height: 15.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.58,92.5v6.41L98.45,99l0-4.44V94l0-1.48a15.84,15.84,0,0,1,6.75-6.36l.14-.07a50.58,50.58,0,0,1,5.87-2.47l.22-1.08a10.49,10.49,0,0,1-2.77-5.12s-3-1.55-1-5c0,0-1.63-9.84,7.89-9.79s7.81,9.78,7.81,9.78a3.43,3.43,0,0,1-.81,5.08s-1.07,4.44-2.87,5l.19,1.06a51.4,51.4,0,0,1,5.33,2.35l.1.06C128.48,87.67,132.06,90,132.58,92.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.62,92.5v6.41L76.49,99l0-4.44V94l0-1.48a15.81,15.81,0,0,1,6.74-6.36l.15-.07a50.58,50.58,0,0,1,5.87-2.47l.22-1.08a10.49,10.49,0,0,1-2.77-5.12s-2.95-1.55-1-5c0,0-1.63-9.84,7.88-9.79s7.82,9.78,7.82,9.78,2.24,2.64-.82,5.08c0,0-1.07,4.44-2.87,5l.2,1.06a50.75,50.75,0,0,1,5.32,2.35l.1.06C106.53,87.67,110.1,90,110.62,92.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.85,98.71v7.82l-41.65.12-.07-5.43V98.76A19.26,19.26,0,0,1,31.33,91l.18-.09a64.44,64.44,0,0,1,7.16-3l.27-1.31a12.86,12.86,0,0,1-3.39-6.25s-3.6-1.89-1.18-6.06c0,0-2-12,9.63-11.95s9.54,11.94,9.54,11.94,2.73,3.23-1,6.2c0,0-1.31,5.42-3.5,6.07l.23,1.3a60.52,60.52,0,0,1,6.5,2.88.52.52,0,0,1,.13.06C59.85,92.81,64.21,95.69,64.85,98.71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.35,98.71v7.82l-41.66.12-.06-5.43V98.76A19.26,19.26,0,0,1,91.83,91L92,90.9a65.54,65.54,0,0,1,7.17-3l.27-1.31a12.86,12.86,0,0,1-3.39-6.25s-3.6-1.89-1.18-6.06c0,0-2-12,9.63-11.95S114,74.26,114,74.26s2.73,3.23-1,6.2c0,0-1.31,5.42-3.5,6.07l.23,1.3a60.52,60.52,0,0,1,6.5,2.88.75.75,0,0,1,.13.06C120.35,92.81,124.71,95.69,125.35,98.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.0099d79613c6f88f50886657e4ae95be.svg";
export { ForwardRef as ReactComponent };